import { useState } from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import TextField from "@mui/material/TextField"
import { MONO, CHAT_COLOR } from "../constants"
import { scrollbarSx } from "../../../shared/scrollbar"
import { GroupImagePicker } from "./GroupImagePicker"
import { MemberPicker } from "./MemberPicker"

export function GroupBuilderPanel({ users, me, onCreate, onCancel }) {
  const [name, setName] = useState("")
  const [image, setImage] = useState("")
  const [selected, setSelected] = useState(new Set())
  const toggle = (u) => setSelected(prev => { const n = new Set(prev); n.has(u) ? n.delete(u) : n.add(u); return n })
  return (
    <Box sx={{ flex: 1, overflowY: "auto", p: 1.5, ...scrollbarSx }}>
      <Typography sx={{ color: CHAT_COLOR, fontFamily: MONO, fontSize: "0.7rem", fontWeight: 600, mb: 1 }}>
        New group chat
      </Typography>
      <GroupImagePicker image={image} onPick={setImage} />
      <TextField value={name} onChange={(e) => setName(e.target.value)} placeholder="Group name"
        size="small" fullWidth
        sx={{ mb: 1.25, "& .MuiInputBase-input": { fontFamily: MONO, fontSize: "0.72rem", color: "#fff" },
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(var(--app-fg-rgb),0.12)" } }} />
      <Typography sx={{ color: "rgba(var(--app-fg-rgb),0.35)", fontFamily: MONO, fontSize: "0.62rem", mb: 0.75 }}>
        Members
      </Typography>
      <MemberPicker users={users} me={me} selected={selected} onToggle={toggle} />
      <Box sx={{ display: "flex", gap: 1, mt: 1.5 }}>
        <Box onClick={() => name.trim() && onCreate(name, [...selected], image)}
          sx={{ flex: 1, textAlign: "center", py: 0.7, borderRadius: 1, cursor: name.trim() ? "pointer" : "default",
            fontFamily: MONO, fontSize: "0.7rem",
            backgroundColor: name.trim() ? "rgba(245,158,11,0.15)" : "rgba(var(--app-fg-rgb),0.04)",
            color: name.trim() ? CHAT_COLOR : "rgba(var(--app-fg-rgb),0.3)",
            border: "1px solid " + (name.trim() ? "rgba(245,158,11,0.3)" : "rgba(var(--app-fg-rgb),0.06)") }}>
          Create
        </Box>
        <Box onClick={onCancel}
          sx={{ flex: 1, textAlign: "center", py: 0.7, borderRadius: 1, cursor: "pointer",
            fontFamily: MONO, fontSize: "0.7rem", color: "rgba(var(--app-fg-rgb),0.4)",
            border: "1px solid rgba(var(--app-fg-rgb),0.08)" }}>
          Cancel
        </Box>
      </Box>
    </Box>
  )
}
